// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router";

import type { AdminStatesType, AdminPropsType } from "../types/UserFormType";
import { ErrosDisplay, setErrorMsg } from "../../global/components/ErrosDisplay";
import LoadingProgress from "../../global/components/LoadingProgress";
import { getUserInfo, getAllUsers } from "../../global/actions/databaseActions";
import { ColorSchema } from "../../global/types/scss";
import { buttonStyles } from "../../global/components/StyledButtons";
import { getCookie } from "../../global/functions/cookies";
import { AdminPrint } from "../../global/functions/AdminPrint";
import AdminPerson from "../component/AdminPerson";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

class Admin extends Component<AdminPropsType, AdminStatesType> {
  constructor(props: AdminPropsType) {
    super(props);
    this.state = {
      errors: {},
      loading: true
    };
  }

  componentDidMount() {
    const accessToken = getCookie("access_token");
    if (accessToken === "") {
      this.setLoadError("Access Code is not correct. Please check your Access Link.");
    }
    else {
      if (this.props.db.conference.id !== undefined && this.props.db.user === undefined) {
        this.props.actions.getUserInfo(this.props.db.conference.id, accessToken, "", (): * => null);
      }
      this.props.actions.getAllUsers(this.props.db.conference.id, accessToken, this.finishFetching, (): * => this.setLoadError("You don't have authority to view this."));
    }
  }

  shouldComponentUpdate(nextProps: AdminPropsType): boolean {
    if (this.props.db.updating > 0 && nextProps.db.updating > 0) {
      return false;
    }
    return true;
  }

  finishFetching = () => {
    this.setState({ loading: false });
  }

  setLoadError = (error: string): * => {
    if (error === "") {
      this.setState({ errors: setErrorMsg(this.state.errors, "access_token", "", true) });
    }
    else {
      this.setState({ errors: setErrorMsg(this.state.errors, "access_token", error) });
    }
  }

  loadMorePeople = (): * => {
    this.setState({ loading: true });

    const accessToken = getCookie("access_token");
    let people = [...this.props.db.people];
    const person_uid = people.slice(-1)[0].uid;
    this.props.actions.getAllUsers(this.props.db.conference.id, accessToken, this.finishFetching, () => this.setLoadError("You don't have authority to view this."), person_uid);
  }

  print = (): * => {
    AdminPrint("data-table", this.props.db.conference, this.props.db.count, ColorSchema("primary"));
  }

  render(): React$Element<*> {
    const classes = this.props.classes;
    const conferenceFields = this.props.db.conference.additional_person_fields;
    const width = 720 / (conferenceFields.length + 5);
    const extraHeaders = conferenceFields.map((field: *): * => (
      <TableCell className="border">{field.name}</TableCell>
    ));
  
    return (
      <div>
        <div className="top-banner">
          <ErrosDisplay errors={this.state.errors} form="user" />
        </div>
        {this.props.db.user &&
          <Grid container spacing={8}>
            <Grid item xs={12} className="hint-margin-bottom" style={{ display: "flex" }}>
              <Typography variant="title" className="form-text bottom-margin-10">{this.props.db.count} People Enrolled in Total</Typography>
              <Button variant="raised" color="primary" className={classes.shineBtn} onClick={this.print}>
                Print
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Paper style={{ overflowX: "auto" }}>
                <Table className="app-table" id="data-table">
                  <TableHead>
                    <TableRow>
                      <TableCell className="border">First Name</TableCell>
                      <TableCell className="border">Last Name</TableCell>
                      <TableCell className="border">Organisation / Company</TableCell>
                      <TableCell className="border">Email</TableCell>
                      <TableCell className="border" style={{ width: "80px" }}>Photos</TableCell>
                      {extraHeaders}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.props.db.people && this.props.db.people.map((person: *, i: number) => (
                      <AdminPerson key={"person" + i} person={person} conferenceFields={conferenceFields} />
                    ))}
                  </TableBody>
                </Table>
              </Paper>
              {this.props.db.people.length < this.props.db.count &&
                <Button color="primary" variant="raised" type='button' className={classes.primaryBtn + " top-margin-30"} style={{ width: "60%", margin: "0 20%" }} onClick={this.loadMorePeople}>Load More</Button>
              }
            </Grid>
            <Grid item xs={12}>
              {this.state.loading &&
                <div className="form-text">
                  <LoadingProgress size={100} />
                </div>
              }
            </Grid>
          </Grid>
        }
        <Typography variant="body1" className="form-text top-margin-30">
          <Link to={"/" + this.props.params.conference + "/profile"} className="form-link-green" style={{ color: ColorSchema("primary") }}>Back to My Profile</Link>
        </Typography>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ getUserInfo, getAllUsers }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(buttonStyles)(Admin));


// WEBPACK FOOTER //
// ./src/conference/views/Admin.js